module.exports = __webpack_public_path__ + "static/media/r266.43802797.jpg";